import { render } from "./IRadioButtons.vue?vue&type=template&id=0cd32036"
import script from "./IRadioButtons.vue?vue&type=script&lang=js"
export * from "./IRadioButtons.vue?vue&type=script&lang=js"

import "./IRadioButtons.vue?vue&type=style&index=0&id=0cd32036&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__